import { useContext, useState, useCallback } from "react";
import AuthContext from "../store/auth-context";
import { signin, signup } from "../services";


const useAuth = () => {
  const authCtx = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const sendLoginRequest = useCallback(async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      // Include rememberMe in login request so backend can issue appropriate token expiry
      const res = await signin(data);
      if (res.status === 200 && res.data) {
        // Pass both response data and rememberMe flag to auth context. Resolves once
        // the full user record has loaded.
        await authCtx.login(res.data, data.rememberMe);

        setError(null);
      } else if (res.status === 404) {
        setError('Invalid Email or Password');
      } else {
        setError('An unexpected error occurred');
      }
      return res;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unexpected error occurred');
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, [authCtx]);

  const sendRegisterRequest = useCallback(async (data) => {
    setError(null);
    setIsLoading(true);
    try {
      const res = await signup(data);
      if (res.status === 201) {
        setError(null);
        // Note: We're not logging in the user automatically after registration
        // If you want to, you can call authCtx.login(res.data) here
      } else if (res.status === 400) {
        setError(res.message || 'Registration failed');
      } else {
        setError('An unexpected error occurred');
      }
      return res;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unexpected error occurred');
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    authCtx.logout();
    // Force page reload to ensure clean state
    window.location.href = "/login";
  }, [authCtx]);

  return {
    sendRegisterRequest,
    sendLoginRequest,
    logout,
    isLoading,
    error,
    isLoggedIn: authCtx.isLoggedIn,
    isFreeTier: authCtx.isFreeTier,
    isVipPlus: authCtx.isVipPlus,
    userData: authCtx.userData
  };
};

export default useAuth;

